/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SaSheetWorkingTimeData { 
    id?: string;
    sheet_id?: string;
    sheet_staff_id?: string;
    in_out_log_id?: string;
    start?: Date;
    finish?: Date;
    working_hour?: number;
    late_comming?: number;
    soon_comback?: number;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    note?: string;
}